import React, { Component } from 'react';

import { BrowserRouter, Route } from 'react-router-dom';

import ToolScreen from './screens/ToolScreen';
import ModelColor from './screens/ModelColor';
import SelectTool from './screens/SelectTool';
import SurveyScreen from './screens/SurveyScreen';
import SelectShowCard from './screens/SelectShowCard';
import ShowCards from './screens/ShowCards';
import ViewModel from './screens/ViewModel';


class App extends Component {
    render(){
        return (
            <BrowserRouter>
                <div>
                    <Route path="/model-color" exact component={ModelColor} />
                    <Route path="/" exact component={SelectTool} />
                    <Route path="/to-mau" exact component={SurveyScreen} />
                    <Route path="/mau-xe" exact component={ViewModel} />
                    <Route path="/tool/" component={ToolScreen} />
									<Route path="/show-cards/:id?" component={ShowCards} />
                </div>
            </BrowserRouter>
        );
    }
}

export default App;
